import React from 'react';

export default function GraphmlEmptyState() {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', height: '60vh', gap: 16, padding: 48,
      textAlign: 'center',
    }}>
      <div style={{ fontSize: 48 }}>📡</div>
      <h2 style={{ margin: 0, color: '#1e293b', fontSize: 20, fontWeight: 600 }}>
        No dependency graph available yet
      </h2>
      <p style={{ margin: 0, color: '#64748b', maxWidth: 480, lineHeight: 1.6 }}>
        The Architecture canvas requires a dependency graph uploaded by your
        CI/CD pipeline. Once your pipeline runs and uploads a{' '}
        <code>.graphml</code> file, come back here to draw your architecture
        components and run validation.
      </p>
      <p style={{ margin: 0, color: '#94a3b8', fontSize: 13 }}>
        Need help? Check your CI/CD configuration to ensure the{' '}
        <code>.graphml</code> file is included in the upload step.
      </p>
    </div>
  );
}
